<template>
  <div>
    <video
      ref="videoPlayer"
      class="video-js"
      :controls="controls"
      :id="`videoStream${playerId}`"
      v-bind="$attrs"
    ></video>
  </div>
</template>

<script>
import Hls from 'hls.js'

export default {
  name: 'HlsPlayer',
  props: {
    src: {
      type: String,
    },
    playerId: {
      type: String,
      default: '',
    },
    controls: {
      type: Boolean,
      default: false,
    },
    isRecording: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      player: null,
      hls: null,
      isRecordingLocal: false,
      arrayRecord: [],

      mediaRecorder: null,
      recordedChunks: [],
      recordedBlob: null,
      supportedType: '',
    }
  },
  // watch: {
  //   isRecording(val) {
  //     const self = this
  //     var dataStream = { video: [], audio: [] }
  //     if (val) {
  //       this.hls.on(Hls.Events.BUFFER_APPENDING, function (event, data) {
  //         dataStream[data.type].push(data.data)
  //       })
  //     } else {
  //       dataStream = { video: [], audio: [] }
  //       this.arrayRecord.push({ url: this.src, hls: this.hls, data: dataStream })

  //       this.arrayRecord.forEach(function (item) {
  //         // if (item.url == this.src) {
  //         self.downloadMP4(item.data['video'])
  //         item.hls.destroy()
  //         // return false
  //         // }
  //       })
  //     }
  //     this.isRecordingLocal = val
  //   },
  // },
  // watch: {
  //   isRecording(val) {
  //     if (val) {
  //       this.startRecording()
  //     } else {
  //       this.stopRecording()
  //     }
  //     this.isRecordingLocal = val
  //   },
  // },
  mounted() {
    if (this.src != '' && this.src != null) {
      if (this.src.includes('.mp4') || this.src.includes('.MP4')) {
        setTimeout(() => {
          this.addSourceToVideo()
        }, 500)
      } else {
        this.initialize()
      }
    }
  },
  beforeDestroy() {
    if (this.hls) {
      this.hls.stopLoad()
    }
  },
  methods: {
    initialize() {
      if (Hls.isSupported()) {
        if (this.hls) {
          this.hls.stopLoad()
        }
        this.player = this.$refs.videoPlayer
        this.hls = new Hls()
        this.hls.loadSource(this.src)
        this.hls.attachMedia(this.$refs.videoPlayer)

        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          this.player.play()
          this.$emit('ready')
        })

        this.hls.on(Hls.Events.ERROR, () => {
          this.$emit('error')
        })

        this.hls.on(Hls.Events.FRAG_LOADED, (event, data) => {
          this.player.play()
          this.$emit('loadeddata', event, data, this.hls.bandwidthEstimate)
        })

        // this.hls.on(Hls.Events.BUFFER_APPENDING, function (event, data) {
        //   console.log(event)
        //   console.log(data)
        // })

        this.player.addEventListener('playing', () => {
          this.$emit('playing')
          this.player.play()
        })

        this.player.addEventListener('play', () => {
          this.$emit('play')
          this.player.play()
        })

        this.player.addEventListener('pause', () => {
          this.$emit('pause')
        })

        this.player.addEventListener('ended', () => {
          this.$emit('ended')
        })
      }
    },
    addSourceToVideo() {
      this.player = this.$refs.videoPlayer
      const video = document.getElementById(`videoStream${this.playerId}`)
      let source = document.createElement('source')
      source.src = this.src
      source.type = 'video/mp4'
      video.appendChild(source)

      this.player.addEventListener('loadeddata', () => {
        this.$emit('ready')
      })

      this.player.addEventListener('error', (event) => {
        this.$emit('error', event)
      })

      this.player.addEventListener('playing', () => {
        this.$emit('playing')
      })

      this.player.addEventListener('play', () => {
        this.$emit('play')
      })

      this.player.addEventListener('pause', () => {
        this.$emit('pause')
      })

      this.player.addEventListener('ended', () => {
        this.$emit('ended')
      })

      this.player.addEventListener('volumechange', () => {
        this.$emit('volumechange')
      })
    },
    determineSupportedType() {
      const supportedTypes = [
        'video/webm;codecs=vp8',
        'video/webm;codecs=vp9',
        'video/webm;codecs=vp8.0',
        'video/webm;codecs=vp9.0',
        'video/webm',
        'video/mp4',
        'video/ogg',
      ]

      for (const type of supportedTypes) {
        if (MediaRecorder.isTypeSupported(type)) {
          this.supportedType = type
          break
        }
      }

      if (!this.supportedType) {
        console.error('No supported MIME type found for MediaRecorder')
      }
    },
    startRecording() {
      this.determineSupportedType()

      if (!this.supportedType) {
        alert('Your browser does not support any of the tested MIME types for recording.')
        return
      }

      const video = this.$refs.videoPlayer

      if (!video.captureStream) {
        console.error('Video captureStream is not supported')
        return
      }

      if (video.readyState < 2) {
        video.addEventListener(
          'loadeddata',
          () => {
            this.startRecorder(video.captureStream())
          },
          { once: true }
        )
      } else {
        this.startRecorder(video.captureStream())
      }
    },
    startRecorder(stream) {
      try {
        this.mediaRecorder = new MediaRecorder(stream, {
          mimeType: this.supportedType,
          audioBitsPerSecond: 128000,
          videoBitsPerSecond: 2500000,
        })

        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            console.log('Data available: ', event.data.size)
            this.recordedChunks.push(event.data)
          } else {
            console.log('No data available')
          }
        }

        this.mediaRecorder.onstop = () => {
          console.log('Recording stopped')
          const blob = new Blob(this.recordedChunks, { type: this.supportedType })
          this.downloadUrl = URL.createObjectURL(blob)
          this.$refs.downloadLink.click()
        }

        this.recordedChunks = []
        this.mediaRecorder.start()
        console.log('Recording started')
      } catch (e) {
        console.error('Error starting MediaRecorder:', e)
      }
    },
    stopRecording() {
      this.mediaRecorder.stop()
      this.mediaRecorder.onstop = () => {
        const url = window.URL.createObjectURL(this.recordedBlob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = 'recording.webm'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      }
    },
    downloadMP4(data) {
      console.log('downloading...')
      var blob = new Blob([this.arrayConcat(data)], { type: 'application/octet-stream' })
      var filename = 'video-' + new Date().toISOString() + '.mp4'
      this.saveAs(blob, filename)
    },
    saveAs(blob, filename) {
      var url = URL.createObjectURL(blob)
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    },
    arrayConcat(inputArray) {
      var totalLength = inputArray.reduce(function (prev, cur) {
        return prev + cur.length
      }, 0)
      var result = new Uint8Array(totalLength)
      var offset = 0
      inputArray.forEach(function (element) {
        result.set(element, offset)
        offset += element.length
      })
      return result
    },
  },
}
</script>
